<style scoped lang="less">
    @import "assets/vars.less";

    .service {
        &_page {
            position: relative;
        }
        &_info {
            width: 100%;
            padding: 25px 25px 5px;
            text-align: center;
            > h2 {
                font-weight: 400;
                letter-spacing: 2px;
                color: @dark;
            }
            p {
                color: @dark_gray;
                padding: 0 10%;
                font-size: 14px;
                line-height: 1.5em;
                letter-spacing: .5px;
            }
        }
        &_list {
            list-style-type: none;
            padding: 0 15px 15px;

            display: flex;
            align-items: stretch;
            justify-content: space-around;

            flex-wrap: wrap;

            > li:not(.full_row) {
                width: calc(~"(100% / 3) - 20px");
                padding: 15px;
                margin: 10px;
                border: 3px solid fade(@dark_gray, 50%);
                background: @white;

                @media (max-width: 850px) {
                    width: calc(~"(100% / 2) - 20px");
                }

                @media (max-width: 700px) {
                    width: calc(~"100% - 20px");
                }

                > img {
                    width: 62px;
                    display: block;
                    margin: 0 auto;
                }
                > h3 {
                    color: @dark;
                    margin: 10px 0 25px;
                    font-size: 18px;
                    line-height: 1.2em;
                    font-weight: 800;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    text-align: center;
                }
                > .decor {
                    width: 100%;
                    background: fade(@dark_gray, 50%);
                    height: 3px;
                }
                > p {
                    text-align: center;
                    text-transform: uppercase;
                    font-size: 16px;
                    color: @yellow;
                }
                > .features {
                    list-style-type: none;
                    padding: 0;
                    > li {
                        font-size: 14px;
                        line-height: 1.5em;
                        color: @dark_gray;
                        text-align: center;
                        width: 100%;
                        padding: 15px;
                        border-top: 1px solid fade(@dark_gray, 20%);
                    }
                }
            }

            > li.full_row {
                width: 100%;
                margin: 10px;
                > p {
                    font-size: 14px;
                    line-height: 1.5em;
                    letter-spacing: .5px;
                    color: @dark;
                }
            }
        }
    }
</style>

<template>
    <div>
        <transition name="fade">
            <div class="service_page">
                <transition name="fade">
                    <div v-if="loaded" class="service_data">
                        <div class="service_info">
                            <h2>Услуги</h2>
                            <div class="monogram"></div>
                            <p>
                                Я предлагаю различные услуги по фотосъемке, ознакомиться с которыми вы можете на
                                этой странице.
                            </p>
                        </div>
                        <ul class="service_list">
                            <li>
                                <img src="icons/classic.svg" alt="">
                                <h3>Свадьба:<br/>Классическая</h3>
                                <div class="decor"></div>
                                <p>25 000 Р</p>
                                <ul class="features">
                                    <li>До 8-ми часов съемки</li>
                                    <li>Cборы невесты/жениха, съемка в ЗАГСе, прогулочная фотосессия и съемка на банкете
                                        до первого танца, но не более 2-х часов
                                    </li>
                                    <li>Более 300 фотографий с художественной цветокоррекцией</li>
                                    <li>Авторская серия из 20-30 фотографий с дополнительной художественной обработкой и
                                        ретушью крупных портретов
                                    </li>
                                    <li>Флеш-карта с обработанными фотографиями</li>
                                    <li>2 комплекта флеш-карт для родителей</li>
                                    <li>Cкидка 30% на Love-story</li>
                                </ul>
                            </li>

                            <li>
                                <img src="icons/optimal.svg" alt="">
                                <h3>Свадьба:<br/>Оптимальная</h3>
                                <div class="decor"></div>
                                <p>30 000 Р</p>
                                <ul class="features">
                                    <li>До 12-ти часов съемки</li>
                                    <li>Сборы невесты/жениха, съемка в ЗАГСе, прогулочная фотосессия и съемка банкета
                                        полностью, но не позднее 23:00
                                    </li>
                                    <li>Более 500 фотографий с художественной цветокоррекцией</li>
                                    <li>Авторская серия из 50 фотографий с дополнительной художественной обработкой и
                                        ретушью крупных портретов
                                    </li>
                                    <li>Флеш-карта с обработанными фотографиями</li>
                                    <li>2 комплекта флеш-карт для родителей</li>
                                    <li>Cкидка 50% на Love-story</li>
                                </ul>
                            </li>

                            <li>
                                <img src="icons/premium.svg" alt="">
                                <h3>Свадьба:<br/>Премиум</h3>
                                <div class="decor"></div>
                                <p>45 000 Р</p>
                                <ul class="features">
                                    <li>Рекомендуется для больших свадеб (от 80-ти гостей)</li>
                                    <li>Съемка полного свадебного дня</li>
                                    <li>Два фотографа на свадьбе</li>
                                    <li>Более 1000 фотографий с художественной цветокоррекцией</li>
                                    <li>Авторская серия из 100 фотографий</li>
                                    <li>Флеш-карта с обработанными фотографиями</li>
                                    <li>2 комплекта флеш-карт для родителей</li>
                                    <li>Создание слайд-шоу</li>
                                    <li>Свадебная книга 30х20 см</li>
                                    <li>Cкидка 70% на Love-story</li>
                                </ul>
                            </li>

                            <li class="full_row">
                                <p>Наш стандартный съемочный день начинается не раньше 8:00 и заканчивается не позднее
                                    23:00.
                                    Но вы всегда можете заказать нужное вам количество дополнительных съемочных часов.
                                    Дополнительные часы работы сверх установленного времени оплачиваются из условия
                                    3 000 рублей в час.
                                </p>
                                <p>
                                    Дополнительная художественная обработка и ретушь фотографий: 100
                                    рублей за 1 фотографию.
                                </p>
                                <p>Дополнительный комплект фирменной флеш-карты 1000 рублей.</p>
                                <p>
                                    Создание слайд-шоу - 3 000 рублей.
                                </p>
                            </li>

                            <li>
                                <img src="icons/story.svg" alt="">
                                <h3>Love Story</h3>
                                <div class="decor"></div>
                                <p>10 000 Р</p>
                                <ul class="features">
                                    <li>Съемка проводится в любой день, кроме пятницы и субботы</li>
                                    <li>До 3-х часов съемки (в нескольких локациях)</li>
                                    <li>100-150 фотографий с художественной цветокоррекцией</li>
                                    <li>Флеш-карта с обработанными фотографиями</li>
                                </ul>
                            </li>

                            <li>
                                <img src="icons/book.svg" alt="">
                                <h3>Свадебные книги</h3>
                                <div class="decor"></div>
                                <p>от 7 000 Р</p>
                                <ul class="features">
                                    <li>Формат книги 30х30 см или 30х20 см</li>
                                    <li>Виды обложек фотообложки, обложки из ткани, натуральной и искусственной кожи
                                    </li>
                                    <li>Возможен заказ футляров и коробок для книг</li>
                                </ul>
                            </li>

                            <li>
                                <img src="icons/sessions.svg" alt="">
                                <h3>Фотосессии</h3>
                                <div class="decor"></div>
                                <p>4 000 Р</p>
                                <ul class="features">
                                    <li>1 час съемки (в студии<sup>*</sup>, интерьере или на улице)</li>
                                    <li>50 фотографий с цветокоррекцией</li>
                                    <li>15 фотографий с художественной обработкой и ретушью</li>
                                    <li>Флеш-карта с обработанными фотографиями</li>
                                    <li><sup>*</sup> аренда студии оплачивается отдельно</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'services',
        data () {
            return {
                loaded: false,
            };
        },
        mounted () {
            setTimeout(() => {
                this.loaded = true;
            }, 200);
        },
    };
</script>